import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Select from 'react-select'
import { Paragraph } from '../Paragraph/Paragraph'
import pxToRem from '../../utils/pxToRem'

const classNamePrefix = 'react-select'

const SelectContainer = styled.div`
  position: relative;
  display: flex;
`

const StyledSSGSelect = styled.select`
  flex: 1;
  padding: 0 ${pxToRem(10)};
  padding-right: 2rem;
  width: 100%;
  min-width: 10rem;
  height: ${pxToRem(40)};
  border: initial;
  border-radius: ${pxToRem(5)};
  background-color: ${({ theme }) => theme.colors.secondary.grey95};
  color: ${({ theme }) => theme.colors.custom.battleshipGrey};
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  line-height: ${pxToRem(24)};
  font-family: ${({ theme }) => theme.fonts.family.sans};
  -webkit-appearance: none;
`

const StyledSelect = styled(Select)`
  flex: 1;
  width: 100%;
  min-width: 10rem;
  .react-select__placeholder {
      color: ${({ theme }) => theme.colors.custom.battleshipGrey};
  }
  .react-select__option--is-focused {
    z-index: 100;
    background-color: ${({ theme }) => theme.colors.main.grayLight};
  }
  .react-select__option--is-selected {
    background-color: ${({ theme }) => theme.colors.primary.blue};
  }
  .react-select__control {
    background-color: ${({ theme }) => theme.colors.secondary.grey95};
    border-width: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: ${pxToRem(2)} 0;
  }
  .react-select__dropdown-indicator {
      color: ${({ theme }) => theme.colors.unique.black};  
  }
  .react-select__clear-indicator {
      color: ${({ theme }) => theme.colors.unique.black};
  }
  .react-select__indicator-separator {
    width: 0;
  }
`

const Error = styled(Paragraph)`
  left: 1rem;
  bottom: -0.5rem;
  position: absolute;
  color: ${({ theme }) => theme.colors.main.danger};
`

const SelectComponent = (props) => {
  // options: array of objects with "value" and "label"
  // action: callback function
  const {
    className,
    error,
    isClearable,
    onChange,
    options,
    value,
    isMulti,
    placeholder,
  } = props

  const OnChangeSelection = (selection) => {
    if (onChange) {
      return onChange({ select: selection })
    }
    return
  }

  const isBrowser = typeof window !== 'undefined'

  return (
    <SelectContainer className={className}>
      {isBrowser ? (
        <StyledSelect
          classNamePrefix={classNamePrefix}
          onChange={OnChangeSelection}
          options={options}
          defaultValue={value}
          isMulti={isMulti}
          isClearable={isClearable}
          placeholder={placeholder}
        />
      ) : (
        <StyledSSGSelect>
          <option value="">{placeholder}</option>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.value}
            </option>
          ))}
        </StyledSSGSelect>
      )}
      {error && <Error>{error}</Error>}
    </SelectContainer>
  )
}

SelectComponent.propTypes = {
  className: PropTypes.any,
  isClearable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.any,
}

export default SelectComponent
